
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
name: "Payinfo",
components: {Group, XInput, XButton, Confirm, XTextarea},
directives: {TransferDom},
data() {
return {
opid: localStorage.getItem('userid'),
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
seq: this.$route.query.seq,
payInfo: {},
rejectshow: false,
reject_advice: '',
role: this.$route.query.role,
payList: this.$route.query.payList,
}
},
methods: {
payForAnother() {
this.$http.get("/api/v1/users/" + this.opid, this.header).then(response => {
let company = response.data.detail.company;
this.$http.get('/api/v1/companies?company=' + company + '&offset=0&count=1&status=AUDITED').then(response => {
if (response.data['list'].length === 0) {
alert('未找到所属单位')
} else {
this.$http.post('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/ask_other_pay_repair', {
role: 'INDV',
other_id: response.data['list'][0].userid.toString(),
other_type: 'ENTP'
}, this.header).then(response => {
this.$vux.toast.show({
text: '已转给该用户',
type: 'success',
time: '1000'
})
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
rejectResult(seq) {
this.$http.post("/api/v1/payments/" + this.opid + "/orders/" + seq + "/user_reject_pay_repair", {
role: 'INDV',
reason: this.reject_advice
}, this.header).then(() => {
this.rejectshow = false
this.reload()
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
},
reload() {
this.$http.get('/api/v1/payments/' + this.opid + '/orders/' + this.seq + '/get_repair_wait_user_to_pay?role=INDV', this.header)
.then(response => {
this.payInfo = response.data
this.payInfo.sbst = this.payInfo.sbst ? '是' : '否'
switch (this.payInfo.state) {
case 'WAIT':
this.payInfo.state = '待支付';
break;
case 'SUCCESS':
this.payInfo.state = '支付成功';
break;
case 'REJECT':
this.payInfo.state = '拒绝支付';
break;
case 'FAIL':
this.payInfo.state = '支付失败';
break;
case 'MAN_CONF':
this.payInfo.state = '等待人工确认';
break;
case 'BG_CONF':
this.payInfo.state = '等待后台确认';
break;
}
switch (this.payInfo.pconfirm) {
case 'WAIT':
this.payInfo.pconfirm = '待确认';
break;
case 'CONFIRMED':
this.payInfo.pconfirm = '已确认';
break;
case 'REJECT':
this.payInfo.pconfirm = '拒绝';
break;
}
switch (this.payInfo.sconfirm) {
case 'WAIT':
this.payInfo.sconfirm = '待确认';
break;
case 'CONFIRMED':
this.payInfo.sconfirm = '已确认';
break;
case 'REJECT':
this.payInfo.sconfirm = '拒绝';
break;
}
switch (this.payInfo.method) {
case 'CHANGE':
this.payInfo.method = '零钱';
break;
case 'WX':
this.payInfo.method = '微信';
break;
case 'BANK':
this.payInfo.method = '线下转账';
break;
}
})
.catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
})
}
},
created() {
this.reload()
},
beforeRouteLeave(to, from, next) {
if (to.name === 'Userpay') {
to.params.role = this.role
to.params.info = this.payList
}
next()
}
}



// WEBPACK FOOTER //
// ./src/components/Pay/Payinfo.vue